/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import propTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, publicRoute, isAuthorized, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      isAuthorized ? (<Component {...props} />)
        : (<Redirect to={{ pathname: publicRoute }} />)
    )}
  />
);

PrivateRoute.propTypes = {
  component: propTypes.func.isRequired,
  publicRoute: propTypes.string.isRequired,
  isAuthorized: propTypes.bool.isRequired,
};

export default PrivateRoute;
